import React from 'react';

import { Form } from 'antd';
import styled from 'styled-components';

import Checkbox from 'components/lib/Checkbox';
import { Divider } from 'components/lib/Divider';
import Radio from 'components/lib/Radio';
import { VALUE_DIFFERENCE_DISPLAY } from 'components/View/constants';

import { useCompareCommunitiesFilterContext } from './CompareCommunitiesFilterContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Section = styled.div`
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
`;

const Title = styled.div<{ disabled?: boolean }>`
  font-family: var(--font-bold);
  font-size: 12px;
  margin-bottom: 10px;
  letter-spacing: 0.5px;
  color: ${({ disabled }) => (disabled ? 'var(--text-secondary)' : 'var(--text-primary')};
`;

const StyledCheckbox = styled(Checkbox)`
  font-size: 14px;
`;

const RadioColumn = styled(Radio.Group)`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

const StyledRadio = styled(Radio) <{ disabled?: boolean }>`
  font-size: 14px;
  color: ${({ disabled }) => (disabled ? 'var(--text-secondary)' : 'var(--text-primary')};
`;

const CompareCommunitiesFilterContent = () => {
  const { form } = useCompareCommunitiesFilterContext();
  const isComparisonTypeEnabled = Form.useWatch('comparisonTypeEnabled', form);

  return (
    <Container>
      <Section>
        <Title>SELECT COMPARISON TYPE</Title>
        <Form.Item name="comparisonTypeEnabled" valuePropName="checked">
          <StyledCheckbox className="green">My community vs. competitors</StyledCheckbox>
        </Form.Item>
      </Section>
      <Divider />
      <Section>
        <Title disabled={!isComparisonTypeEnabled}>VALUE DIFFERENCE DISPLAY</Title>
        <Form.Item name="valueDisplay">
          <RadioColumn disabled={!isComparisonTypeEnabled}>
            <StyledRadio disabled={!isComparisonTypeEnabled} value={VALUE_DIFFERENCE_DISPLAY.AMOUNTS}>
              Amount
            </StyledRadio>
            <StyledRadio disabled={!isComparisonTypeEnabled} value={VALUE_DIFFERENCE_DISPLAY.PERCENTAGES}>
              Percentage
            </StyledRadio>
          </RadioColumn>
        </Form.Item>
      </Section>
    </Container>
  );
};

export default CompareCommunitiesFilterContent;
